<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        لیست درخواست رزرو اتاق
      </h4>
    </b-card-header>
    <b-card-body>
      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
              :fields="fields"
              :items="items"
              hover
              striped
              responsive
          >
            <template #table-busy>
              <div class="text-center text-info my-2">
                <b-spinner class="align-middle"/>
                <strong> درحال دریافت اطلاعات...</strong>
              </div>
            </template>

            <template #cell(date)="data">
              {{ data.item.startAt }} الی {{ data.item.endAt }}
            </template>
            <template #cell(status)="data">
              <b-badge
                  :variant="data.value.label"
                  class="mr-1"
              >
                {{ data.value.title }}
              </b-badge>
            </template>
            <template #cell(action)="data">
              <b-dropdown
                  text="عملیات"
                  variant="outline-primary"

              >
                <b-dropdown-item @click="getDetail(data.item.id)">
                  <feather-icon
                      icon="EyeIcon"
                      class="text-info"
                  />
                  مشاهده
                </b-dropdown-item>
                <b-dropdown-item v-if="data.item.canUpdate"
                                 :to="{name: 'RoomReservation_Edit', params:{id: data.item.id}}">
                  <feather-icon
                      icon="EditIcon"
                      class="text-warning"
                  />
                  ویرایش
                </b-dropdown-item>
                <b-dropdown-item v-if="data.item.canCancel" @click="deleteRequest(data.item.id)">
                  <feather-icon
                      icon="TrashIcon"
                      class="text-danger"
                  />
                  حذف
                </b-dropdown-item>
              </b-dropdown>
            </template>

          </b-table>
          <b-pagination
              v-model="currentPage"
              class="mt-2"
              :total-rows="totalRows"
              :per-page="perPage"
          />
        </div>
      </b-overlay>

      <b-modal
          ref="submitProject"
          v-model="showDetail"
          ok-title="بستن"
          ok-only
      >
        <dl v-if="showDetail">
          <dt><b>نام اتاق</b></dt>
          <dd>{{ detail.room ? detail.room.name : 'فرقی ندارد' }}</dd>
          <dt><b>تاریخ رزرو</b></dt>
          <dd>
            <bdi>{{ detail.start_at_jalali }} الی {{ detail.end_at_jalali }}</bdi>
          </dd>
          <dt><b>وضعیت</b></dt>
          <dd>
            <b-badge
                :variant="detail.status.label"
                class="mr-1"
            >
              {{ detail.status.title }}
            </b-badge>
          </dd>
          <dt v-if="detail.description"><b>توضیحات</b></dt>
          <dd v-if="detail.description" v-html="detail.description"></dd>
          <dt><b>تاریخ درخواست</b></dt>
          <dd>
            {{ detail.createdAt }}
          </dd>
          <dt v-if="detail.action_at"><b>تاریخ رد/تأیید</b></dt>
          <dd>
            {{ detail.action_at }}
          </dd>
          <dt v-if="detail.admin_description"><b>توضیحات مدیر</b></dt>
          <dd v-html="detail.admin_description"></dd>
        </dl>
      </b-modal>

    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BSpinner,
  BBadge,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BPagination, BFormInput, BCollapse, BFormGroup, BButton, VBToggle, BAvatar, BFormInvalidFeedback, BForm, BModal,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import {ValidationProvider} from "vee-validate";
import store from "@/store";

export default {
  name: 'Room_List',
  components: {
    ValidationProvider, BModal, BForm, BFormInvalidFeedback,
    BAvatar,
    BButton,
    VSelect,
    BFormGroup,
    BCollapse,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BPagination,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'شناسه',
        },
        {
          key: 'room.name',
          label: 'نام اتاق',
        },
        {
          key: 'date',
          label: 'ساعت رزرو',
        },
        {
          key: 'status',
          label: 'وضعیت',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      onProgress: true,
      showDetail: false,
      detail: {}
    }
  },

  mounted() {
    this.getRoomList()
  },
  methods: {
    getRoomList() {
      this.onProgress = true
      this.$http.get('room-reservations', {
        params: {
          page: this.currentPage,
        },
      })
          .then(({data}) => {
            if (data.status) {
              this.items = data.rooms
              this.currentPage = data.meta.current_page
              this.totalRows = data.meta.total
              this.perPage = data.meta.per_page
            } else {
              this.$bvToast.toast(data.message ?? 'در دریافت لیست اتاق جلسات خطایی رخ داده', {
                title: 'حطا',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    deleteRequest(id) {
      this.$swal({
        title: 'حذف درخواست ',
        text: 'آیا از حذف رزرو اتاق جلسه مطمئن هستید؟',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'لغو حذف',
        confirmButtonText: 'حذف درخواست',
        customClass: {
          confirmButton: 'btn btn-danger mr-2',
          cancelButton: 'btn btn-success',
        },
      })
          .then(async result => {
            if (result.value) {
              this.$swal({
                title: 'در حال انجام',
                text: 'لطفا تا دریافت نتیجه منتظر بمانید',
                icon: 'info',
                confirmButtonText: 'متوجه شدم',
              })
              await this.$http.put(`room-reservations/${id}/cancel`)
                  .then(({data}) => {
                    if (data.status) {
                      this.$swal({
                        title: 'حذف شد',
                        text: 'حذف درخواست  با موفقیت انجام شد',
                        icon: 'success',
                        confirmButtonText: 'متوجه شدم',
                        timer: 2000,
                      })
                      this.getRoomList()
                    } else {
                      this.$swal({
                        title: 'حذف انجام نشد',
                        text: data.message ?? 'ارتباط با وبسرویس انجام نشد',
                        icon: 'error',
                        confirmButtonText: 'متوجه شدم',
                        timer: 4000,
                      })
                    }
                  })
                  .catch(error => {
                    this.$swal({
                      title: 'حذف انجام نشد',
                      text: error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد',
                      icon: 'error',
                      confirmButtonText: 'متوجه شدم',
                      timer: 4000,
                    })

                  })
            }
          })
    },
    getDetail(id) {
      this.$http.get(`room-reservations/${id}`)
          .then(({data}) => {
            if (data.status) {
              this.detail = data.reservation
              this.showDetail = true
            } else {
              this.$bvToast.toast(data.message ?? 'در دریافت جزییات رزرو اتاق جلسات خطایی رخ داده', {
                title: 'حطا',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
      this.$http.get('room-reservations/notification')
          .then(({data}) => {
            store.commit('roomReservation/ADD_RESERVATION_TO_LIST', data)
          })
    }

  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'Room_Update',
          query: {page: this.currentPage},
        })
        this.items = []
        this.getRoomList()
      }
    },
  },
}
</script>

<style>

</style>
